import {service as StakeholderTypeService} from "../../Services/StakeholderTypeService";
import {service as ConfirmationAgencyService} from "../../Services/ConfirmationAgencyService";
import {service as HucService} from "../../Services/HucService";
import {service as RiverService} from "../../Services/RiverService";
import {service as SampleEventPhaseService} from "../../Services/SampleEventPhaseService";
import {service as SampleEventTypeService} from "../../Services/SampleEventTypeService";
import {service as EcoregionService} from "../../Services/EcoregionService";
import {service as UserService} from "../../Services/UserService";
import {service as UserRoleService} from "../../Services/UserRoleService";
import {service as ConservationActionService} from "../../Services/ConservationActionService";
import {service as ConfirmationStatusService} from "../../Services/ConfirmationStatusService";
import {service as ContactService} from "../../Services/ContactService";
import {service as ContactMethodService} from "../../Services/ContactMethodService";
import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {service as EnvironmentalBenefitService} from "../../Services/EnvironmentalBenefitService";
import {service as OrganizationService} from "../../Services/OrganizationService";
import {service as PermitTypeService} from "../../Services/PermitTypeService";
import {service as PermitService} from "../../Services/PermitService";
import {service as ProcedureService} from "../../Services/ProcedureService";
import {service as ProgramService} from "../../Services/ProgramService";
import {service as ProjectService} from "../../Services/ProjectService";
import {service as TagService} from "../../Services/TagService";


import {ServiceDrivenFieldViewer} from "./FieldViewers/ServiceDrivenFieldViewer";
import {service as FunderService} from "../../Services/FunderService";

export const ContactMethodFieldViewer = ServiceDrivenFieldViewer(ContactMethodService);

export const ConfirmationAgencyViewer = ServiceDrivenFieldViewer(ConfirmationAgencyService);
export const ConfirmationStatusViewer = ServiceDrivenFieldViewer(ConfirmationStatusService);
export const EcoregionFieldViewer = ServiceDrivenFieldViewer(EcoregionService);
export const EnvironmentalBenefitServiceViewer = ServiceDrivenFieldViewer(EnvironmentalBenefitService);
export const FunderFieldViewer = ServiceDrivenFieldViewer(FunderService);
export const PermitTypeServiceViewer = ServiceDrivenFieldViewer(PermitTypeService);
export const ProcedureServiceViewer = ServiceDrivenFieldViewer(ProcedureService);
export const OrganizationFieldViewer = ServiceDrivenFieldViewer(OrganizationService);
export const SampleEventPhaseServiceViewer = ServiceDrivenFieldViewer(SampleEventPhaseService);
export const SampleEventTypeServiceViewer = ServiceDrivenFieldViewer(SampleEventTypeService);
export const TagFieldViewer = ServiceDrivenFieldViewer(TagService);
export const StakeholderTypeViewer = ServiceDrivenFieldViewer(StakeholderTypeService);
export {SpeciesListFieldViewer} from './FieldViewers/SpeciesListFieldViewer';
// export const ContextNodeServiceViewer = ServiceDrivenFieldViewer(ContextNodeService);
export const HucFieldViewer = ServiceDrivenFieldViewer(HucService);
export const RiverFieldViewer = ServiceDrivenFieldViewer(RiverService);
export const UserFieldViewer = ServiceDrivenFieldViewer(UserService);
export const UserRoleFieldViewer = ServiceDrivenFieldViewer(UserRoleService);
